<template>
  <div class="page home">
    <van-search
      class="search-bar"
      v-model="keyword"
      :show-action="showAction"
      placeholder="请输入搜索关键词"
      @focus="showSearch"
      @search="changeSearch"
      @cancel="cancelSearch"
    />

    <div class="search-page" v-show="showSearchPage">
      <div class="hd"><i class="ico ico-hot2"></i><span>热门搜索</span></div>
      <div class="bd">
        <span
          v-for="(item, index) in hotKeywordList"
          :key="index"
          @click="changeSearch(item)"
          >{{ item }}</span
        >
      </div>
    </div>
    <div class="list-page" v-show="showList">
      <!-- <div class="tab">
        <div class="tab-menu">
          <span>全部赛事</span>
          <span>国协赛事</span>
          <span>赛事资讯</span>
          <span>获奖公布</span>
        </div>
        <div class="tab-main"></div>
        <div class="tab-main"></div>
        <div class="tab-main"></div>
        <div class="tab-main"></div>
      </div> -->
      <van-tabs
        v-model="activeTab"
        @click="getList"
        @change="changeParams"
        @rendered="initTab"
        sticky
      >
        <van-tab title="全部赛事">
          <van-list
            class="match-list"
            v-model="loading[0]"
            :finished="finished[0]"
            :immediate-check="false"
            finished-text="没有更多了"
            @load="onLoad(0)"
            v-show="!showEmptys[0]"
          >
            <div class="li" v-for="(item, index) in matchList1" :key="index">
              <a class="item" @click="gotoDetail(item)" href="javascript:;">
                <img class="pic" v-lazy="item.image" />
                <p class="title">{{ item.mname }}</p>
              </a>
            </div>
          </van-list>
          <div class="empty-page" v-show="showEmptys[0]">
            <div class="hd"></div>
            <div class="bd">未搜到相关内容</div>
          </div>
        </van-tab>
        <van-tab title="国协赛事">
          <van-list
            class="match-list"
            v-model="loading[1]"
            :finished="finished[1]"
            :immediate-check="false"
            finished-text="没有更多了"
            @load="onLoad(1)"
            v-show="!showEmptys[1]"
          >
            <div class="li" v-for="(item, index) in matchList2" :key="index">
              <a class="item" @click="gotoDetail(item)" href="javascript:;">
                <img class="pic" v-lazy="item.image" />
                <p class="title">{{ item.mname }}</p>
              </a>
            </div>
          </van-list>
          <div class="empty-page" v-show="showEmptys[1]">
            <div class="hd"></div>
            <div class="bd">未搜到相关内容</div>
          </div>
          <!-- <ul class="match-list">
            <li v-for="(item, index) in matchList2" :key="index">
              <a class="item" @click="gotoDetail(item)" href="javascript:;">
                <img class="pic" v-lazy="item.image" />
                <p class="title">{{ item.mname }}</p>
              </a>
            </li>
          </ul> -->
        </van-tab>
        <van-tab title="热门赛事">
          <van-list
            class="match-list"
            v-model="loading[2]"
            :finished="finished[2]"
            :immediate-check="false"
            finished-text="没有更多了"
            @load="onLoad(2)"
            v-show="!showEmptys[2]"
          >
            <div class="li" v-for="(item, index) in matchList3" :key="index">
              <a class="item" @click="gotoDetail(item)" href="javascript:;">
                <img class="pic" v-lazy="item.image" />
                <p class="title">{{ item.mname }}</p>
              </a>
            </div>
          </van-list>
          <div class="empty-page" v-show="showEmptys[1]">
            <div class="hd"></div>
            <div class="bd">未搜到相关内容</div>
          </div>
        </van-tab>
        <van-tab title="获奖公布">
          <van-list
            class="match-award"
            v-model="loading[3]"
            :finished="finished[3]"
            :immediate-check="false"
            finished-text="没有更多了"
            @load="onLoad(3)"
            v-show="!showEmptys[3]"
          >
            <ul>
              <li
                v-for="(item, index) in awardList"
                :key="index"
                :class="item.is_hot == 1 ? 'is-hot' : ''"
              >
                <div style="display: flex;
                            align-items: center;
                            justify-content: space-between;
                            width:100%">
                  <div class="hd" style="width: 80%">
                    <span class="fl" v-if="item.notice_link != ''"><i class="ico ico-announce"></i></span>
                    {{ item.mname }}
                  </div>
                  <div v-if="item.notice_link == ''" class="bd">
                    <span class="fl"><i class="ico ico-award"></i></span>
                    <span class="fr" v-show="item.prizesStr != ''">{{ item.prizesStr }} 更新</span>
                  </div>
                  <div v-else class="bd">
                    <a :href="item.notice_link">点击查看</a>
                  </div>
                </div>
                <div class="fd">
                  <ul class="match-award-list">
                    <li
                      v-for="(item1, index1) in item.children"
                      :key="index1"
                      :data-id="item1.id"
                      :data-grade="item1.win_grade"
                    >
                      <div class="img"><img v-lazy="item1.image" alt="" /></div>
                    </li>
                    <li
                      v-show="
                        item.children != undefined && item.children.length == 10
                      "
                      @click="goDetail(item)"
                    >
                      <div class="more">
                        <span>+<br />查看更多</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </van-list>
          <div class="empty-page" v-show="showEmptys[3]">
            <div class="hd"></div>
            <div class="bd">未搜到相关内容</div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!-- <div class="empty-page" v-show="showEmpty">
      <div class="hd"></div>
      <div class="bd">未搜到相关内容</div>
    </div> -->
    <div class="download" v-if="isShowDownload">
      <a
        class="btn-close"
        href="javascript:void(0)"
        @click="isShowDownload = false"
      ></a>
      <img class="logo" :src="logo" />
      <a
        class="btn-download"
        href="https://a.app.qq.com/o/simple.jsp?pkgname=com.redirect.wangxs.qiantu"
        >下载</a
      >
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import ThumbSlide from "@/components/ThumbSlide.vue";

export default {
  name: "Home",
  components: {
    // Head,
  },
  data: function () {
    return {
      logo: require("@/static/images/logo-2.png"),
      matchList1: [], // 全部赛事
      matchList2: [], // 国协赛事
      matchList3: [], // 热门赛事
      infoList: [], // 赛事资讯
      awardList: [], // 获奖公布
      showEmptys: [false, false, false, false],
      //列表请求参数
      // params: {
      //   page: 1,
      //   limit: 10,
      //   keyword: "",
      // },
      // 请求参数
      page: 1,
      limit: 10,
      keyword: "",
      totalPage: 0,
      loading: [false, false, false, false], // 列表是否在滚动加载中
      finished: [false, false, false, false], // 是否已经全部加载完
      total: [0, 0, 0, 0], // 当前列表总数
      pages: [1, 1, 1, 1], // 当前列表页码
      tabIndex: 0, // 当前tab页index值
      hotKeywordList: [],
      isShowDownload: true,
      searchKey: "", // 上一次搜索词，与当前关键词比对是否触发搜索
      tabKey: ["", "", "", ""], // 记录切换标签时的关键词，如果和当前搜索词一致，就不触发更新数据
      showAction: false, // 是否显示取消按钮
      showSearchPage: false, // 显示搜索相关
      showList: true, // 显示列表
      activeTab: 0, // 默认显示tab
      showEmpty: false, // 是否显示空页面
      // 缓存 matchList 初始化列表，用 list 筛选赋值 matchList
    };
  },
  methods: {
    init() {
      if (this.tools.openInWebview()) {
        this.isShowDownload = false;
      }
      var data = { url: window.location.href };
      this.tools.wx_share_init(data);
      this.getHotList();
    },
    initTab(name) {
      if (name == 0) {
        this.getList(0, "全部赛事");
      }
      // this.page++;
    },
    onLoad(index) {
      // console.log("onLoad: ", this.page);
      // if (this.page > 1) {
      this.getList(index, "全部赛事");
      // }
      // console.log(this.page);
      // this.page++;
    },
    changeParams(name) {
      // console.log("tab chagne: ", this.page);
      this.tabIndex = name;
      this.page = 1;
      this.totalPage = 0;
      if (this.finished[name] && this.tabKey[name] != this.keyword) {
        // 当前存储的关键词和当前搜索的关键词不同，并且加载完毕
        this.finished[name] = false; // 重置搜索
      }
      this.tabKey[name] = this.keyword;
      // console.log(this.tabKey, this.finished);
    },
    getList(name) {
      // this.axios.post(api, params).then((res) => {
      //   list = res.data.data;
      //   console.log(list, params);
      // });
      // console.log("getList page: ", this.page);
      // this.params.page = 1;
      if (this.finished[name]) {
        return;
      }
      let params = {
        keyword: this.keyword,
        page: this.page,
        limit: this.limit,
      };
      switch (name) {
        case 0:
          params.state = 0;
          params.is_hot = 0;
          this.getData(this.tools.api.matchList, params, (res) => {
            if (this.page == 1) {
              this.matchList1 = res.data.data.data;
              this.showEmptys[name] = res.data.data.data.length == 0;
            } else {
              this.matchList1 = this.matchList1.concat(res.data.data.data);
            }
            // console.log(this.matchList1);
          });
          break;
        case 1:
          params.state = 1;
          params.is_hot = 0;
          this.getData(this.tools.api.matchList, params, (res) => {
            if (this.page == 1) {
              this.matchList2 = res.data.data.data;
              this.showEmptys[name] = res.data.data.data.length == 0;
            } else {
              this.matchList2 = this.matchList2.concat(res.data.data.data);
            }
          });
          break;
        case 2:
          params.state = 0;
          params.is_hot = 1;
          this.getData(this.tools.api.matchList, params, (res) => {
            if (this.page == 1) {
              this.matchList3 = res.data.data.data;
              this.showEmptys[name] = res.data.data.data.length == 0;
            } else {
              this.matchList3 = this.matchList3.concat(res.data.data.data);
            }
          });
          break;
        case 3:
          this.getData(this.tools.api.homeAwardList, params, (res) => {
            if (this.page == 1) {
              this.awardList = res.data.data.data;
              this.showEmptys[name] = res.data.data.data.length == 0;
            } else {
              this.awardList = this.awardList.concat(res.data.data.data);
            }
          });
          break;
      }
    },
    getData(api, params, callback) {
      // console.log(list);
      this.axios.post(api, params).then((res) => {
        callback(res);
        if (this.page == 1) {
          this.totalPage = res.data.data.totalPages;
        }
        // console.log("getData totalPage: ", this.totalPage);
        if (this.page < this.totalPage) {
          this.page++;
        } else {
          this.finished[this.tabIndex] = true;
        }
        // console.log(this.tabIndex);
        this.loading[this.tabIndex] = false;
        // list = res.data.data.data;
        // console.log(res, list, this.matchList1);
      });
    },

    initMatchList() {
      // 获取所有数据，如果需要，可以载入默认搜索条件
      let _this = this;
      this.axios.post(this.tools.api.matchList, _this.params).then((res) => {
        this.matchList1 = res.data.data;
      });
    },
    getMatchList1() {
      // 获取所有数据，如果需要，可以载入默认搜索条件
      // let _this = this;
      this.params.page = 1;
      this.axios.post(this.tools.api.matchList, this.params).then((res) => {
        this.matchList1 = res.data.data;
        // console.log(res);
      });
    },
    gotoDetail(item) {
      if (item.match_topics == 1) {
        this.$router.push({
          path: "/month/" + item.id,
        });
      } else {
        if (process.env.NODE_ENV === "development") {
          this.$router.push({
            path: "/detail/" + item.id,
          });
        } else {
          window.location.href =
            this.urlsite + "/matchweb/match/wapDetail/id/" + item.id;
        }
      }
    },
    goDetail(item) {
      // console.log(item);
      // this.$router.push({
      //   path: "/detail/" + item.id,
      // });
      if (process.env.NODE_ENV === "development") {
        this.$router.push({
          path: "/detail/" + item.id,
        });
      } else {
        window.location.href =
          this.urlsite + "/matchweb/match/wapDetail/id/" + item.id;
      }
    },
    goDetailInfo(item) {
      // console.log(item);
      this.axios.post(this.tools.api.addVisit, { id: item.id });
      this.$router.push({
        path: "/detail-info/" + item.id,
      });
    },
    changeSearch(keywords) {
      // 搜索栏已经绑定keyword，不需要再次赋值
      if (keywords != undefined) {
        this.keyword = keywords;
      }

      // 当前搜索标签页的关键词改变
      this.tabKey[this.tabIndex] = this.keyword;
      // keyword绑定search input
      // 优先判断keyword是否与上一次搜索词相同
      if (this.keyword == this.searchKey) {
        // 相同，不进行搜索，直接隐藏相关界面
        this.showSearchPage = false;
        this.showList = true;
      } else {
        // 不同，则搜索对应内容，并且备份上一次搜索词
        this.finished[this.tabIndex] = false;
        this.showSearchPage = false;
        this.showList = true;
        this.page = 1;
        // this.lastKey = this.searchKey;
        this.searchKey = this.keyword;
        this.getList(this.tabIndex);
      }
    },
    cancelSearch() {
      this.showSearchPage = false;
      this.showList = true;
      // 如果关键词输入框为空，则隐藏即可
      // 否则关键词置空，当前数据重置
      this.keyword = "";
      this.changeSearch();
      this.showAction = false;
    },
    showSearch() {
      this.showSearchPage = true;
      this.showList = false;
      this.showAction = true;
    },
    getHotList() {
      // this.axios.post(this.tools.api.hotKeywordList).then((res) => {
      //   if (res.data.code == 200) {
      //     this.hotKeywordList = res.data.data || [];
      //   }
      // });
    },
  },
  created() {
    this.init();
    // console.log(process.env.NODE_ENV);
  },
};
</script>

<style lang="scss">
.home {
  overflow: initial;
  min-height: 100vh;
  // background: #eef1f5;
  background: #fff;
  .van-tab__text {
    // font-size: #{"16PX"};
    /* prettier-ignore */
    font-size: 16PX;
  }
  // .van-tabs__content {
  //   background: #fff;
  // }
  .van-tab--active {
    color: #f77e5e;
  }
  .van-tabs__line {
    background-color: #f77e5e;
  }
  .search-bar {
    position: sticky;
    top: 0;
  }

  .search-page {
    margin-top: 8px;
    padding: 0 44px;
    background: #fff;
    .hd {
      font-size: #{"15PX"};
      i {
        top: -4px;
      }
      line-height: 80px;
    }
    .bd {
      color: #e6895d;
      font-size: #{"14PX"};
      span {
        display: inline-block;
        background: #fcf3ee;
        height: 64px;
        line-height: 64px;
        padding: 0 22px;
        margin: 11px 22px 11px 0;
        border-radius: #{"3PX"};
      }
    }
  }
  .match-list,
  .match-info,
  .match-award {
    padding: 0 0 125px;
  }
  .match-list {
    width: 100%;
    // padding: 0 0 125px;
    // background: #eef1f5;
  }
  .match-list .li {
    background: #fff;
    border-bottom: 20px solid #eef1f5;
    // margin-bottom: 20px;
  }
  .match-list .li .item {
    width: 100%;
    display: block;
    position: relative;
  }
  .match-list .li .item .pic {
    width: 100%;
    height: 375px;
  }
  .match-list .li .item .title {
    font-size: 34px;
    color: #333;
    padding: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .match-info {
    // padding: 10px 0 0;
    li {
      padding: 20px 0 20px;
      overflow: hidden;
      border-bottom: #{"1PX"} solid #f9f9f9;
      .ico-hot3 {
        position: absolute;
        top: 0;
        right: 0;
        margin: 0;
        display: none;
      }
      &.is-hot .ico-hot3 {
        display: block;
      }
      .pic {
        float: right;
        margin-right: 32px;
        width: 245px;
        height: 123px;
        overflow: hidden;
        border-radius: 8px;
        background: #eee;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .text {
        margin-right: 290px;
        margin-left: 32px;
        .h {
          font-size: #{"14PX"};
          line-height: 38px;
          height: 76px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .p {
          font-size: #{"11PX"};
          color: #aaa;
          padding-top: 8px;
          overflow: hidden;
          line-height: 36px;

          & i,
          & span {
            vertical-align: middle;
          }
          & .fl,
          & .fr {
            line-height: 36px;
          }
        }
      }
      .fr {
        padding-right: 10px;
      }
      &.is-hot {
        .fr {
          color: #fc2a2a;
          padding-right: 0;
          & span::after {
            content: "°";
          }
        }
      }
    }
  }
  .match-award {
    margin: 0 30px;
    overflow: hidden;
    & > ul > li {
      padding: 0 0 20px;
      border-bottom: #{"1PX"} solid #f9f9f9;
    }
    .hd {
      font-size: #{"14PX"};
      line-height: 70px;
      height: 70px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .bd {
      .fr {
        color: #aaa;
        font-size: #{"11PX"};
      }
      overflow: hidden;
    }
    .fd {
      margin-top: 6px;
      ul {
        background: #fef2ef;
        padding: 8px;
        white-space: nowrap;
        overflow: auto;
        font-size: 0;
        &::-webkit-scrollbar {
          width: 0px;
          height: 0px;
        }
        // display: -webkit-box;
        // overflow-x: scroll;
        // -webkit-overflow-scrolling: touch;
        li {
          display: inline-block;
          margin-right: 8px;
          width: 138px;
          height: 138px;
          vertical-align: top;
          .img {
            background: #fff;
            border-radius: 4px;
          }
          &:last-child {
            margin-right: 0;
          }
          .more {
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.7);
            text-align: center;
            overflow: hidden;
            span {
              font-size: #{"11PX"};
              display: inline-block;
              padding: 20px 0 0;
              line-height: 50px;
              color: #fff;
            }
          }
        }
      }
    }
  }
  .empty-page {
    background: #ffffff;
    overflow: hidden;
    .hd {
      background-image: url("../static/images/114/blank_search.png");
      background-size: cover;
      background-repeat: no-repeat;
      width: 444px;
      height: 324px;
      margin: 160px auto 0;
    }
    .bd {
      padding: 40px 10px 100px;
      text-align: center;
      font-size: #{"14PX"};
      font-weight: bold;
      color: #666;
    }
  }
  .img {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    align-content: center;
    overflow: hidden;
    img {
      max-width: 100%;
      max-height: 100%;
      transition: all 0.3s ease;
    }
  }
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
  .ico-hot2 {
    background-image: url("../static/images/114/ico-hot2.png");
    width: 26px;
    height: 30px;
  }
  .ico-hot1 {
    width: 28px;
    height: 28px;
    background-image: url("../static/images/114/ico-hot1.png");
  }
  .is-hot .ico-hot1 {
    background-image: url("../static/images/114/ico-hot.png");
  }
  .ico-hot3 {
    width: 32px;
    height: 32px;
    background-image: url("../static/images/114/ico-hot3.png");
  }
  .ico-award {
    background-image: url("../static/images/114/ico-award.png");
    width: 110px;
    height: 40px;
  }
  .ico-announce {
    background-image: url("../static/images/114/ico-hjjx.png");
    width: 110px;
    height: 40px;
  }
  .ico {
    display: inline-block;
    vertical-align: middle;
    background-size: contain;
    position: relative;
    margin-right: 10px;
    background-repeat: no-repeat;
  }
}
</style>
